import classNames from 'classnames';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { CSSProperties, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface NodeEditorLinkProps {
  nodeDefinitionId: number | string | null | undefined;
  nodeName: string | null | undefined;
  children: ReactNode;
  className?: string;
  iconClassName?: string;
  title?: string;
  style?: CSSProperties;
  iconSize?: FontAwesomeIconProps['size'];
}

const NodeEditorLink = ({
  nodeDefinitionId,
  nodeName,
  children,
  className,
  iconClassName,
  title = 'Open node editor',
  style,
  iconSize = 'sm',
}: NodeEditorLinkProps) => {
  if (nodeDefinitionId == null || !nodeName) {
    return <>{children}</>;
  }

  const href = `/node_editor/${nodeDefinitionId}/${encodeURIComponent(String(nodeName))}`;

  return (
    <Link
      to={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        font: 'inherit',
        lineHeight: '1',
        fontWeight: 'inherit',
        verticalAlign: 'baseline',
        ...style,
      }}
      className={classNames('text-reset text-decoration-none hover-text-1100 d-inline-flex align-items-baseline gap-1', className)}
      title={title}
    >
      <FontAwesomeIcon icon={faLink} className={classNames(iconClassName ?? 'text-600')} size={iconSize} />
      <span>{children}</span>
    </Link>
  );
};

export default NodeEditorLink;
